module.exports = __webpack_public_path__ + "img/CACIB.2a6cc2de.png";